export class CancellationPoliciesServiceError extends Error {
    constructor(message: string) {
        super(message);
        this.message = message;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CancellationPoliciesServiceError);
        }

        this.name = 'CancellationPoliciesServiceError';
    }

    static fromMissingSupplier(): CancellationPoliciesServiceError {
        return new CancellationPoliciesServiceError('Supplier service was not able to return an identifier for this supplier during initialisation');
    }

    static fromInvalidProperty(property: string, expectedType: string, value: unknown): CancellationPoliciesServiceError {
        return new CancellationPoliciesServiceError(`Required property \`${property}\` was invalid. Expected ${expectedType}, got ${typeof value}`);
    }
}

export default CancellationPoliciesServiceError;
